import { Input as InputComponent } from '@mantine/core'

import styles from './input.module.scss'

export const Input = InputComponent.extend({
  classNames: {
    input: styles.input,
  },
})
